let baseState = () => {
  return {
    users: {},
    newUser: {
      id: 0,
      username: '',
      email: '',
      roles: [],
      sites: []
    },
    perPage: '25',
    currentPage: 1,
    totalPageCount: 1,
    assignedRoles: [],
    selectedRoles: [],
    assignedSites: [],
    selectedSites: []
  }
}

const state = baseState()

export default state
export { baseState }
